import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { LuX } from "react-icons/lu";
import { RootState } from "../../Redux/store";
import { CiButton } from "./Ui";
import { useCiT } from "./i18n";

/**
 * "Problem batayein" — customer ek line me dikkat likhta hai, ticket LohaWala ke
 * lhw_tickets me app='cvf' ke saath banta hai (RPC lhw_ticket_submit, anon key —
 * wahi key jo public/lhw-diagnostics.js me hai; sirf INSERT/RPC, padh nahi sakta).
 * Diagnostic Center Tickets me "Chawla Ispat" ke neeche dikhta hai.
 */
const SB_URL = "https://taomwkmknyjbofgbfmpl.supabase.co";
const SB_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRhb213a21rbnlqYm9mZ2JmbXBsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA4MzczMDYsImV4cCI6MjA5NjQxMzMwNn0.3LHLLcfO6GXoCz8rp8wiXXxZ_ZAzqrTxIZufTnnaqK4";

const moduleOf = (path: string): string => {
  const s = (path.split("/")[1] || "home").toLowerCase();
  if (s === "c" || s === "items" || s === "subitems") return "listing";
  return s || "home";
};

export const submitProblem = async (input: { title: string; description: string; username?: string; phone?: string }) => {
  const meta = {
    url: window.location.href,
    ua: navigator.userAgent.slice(0, 200),
    lang: (() => { try { return localStorage.getItem("ci_lang") || "en"; } catch { return "en"; } })(),
    vid: (() => { try { return localStorage.getItem("ci_vid") || null; } catch { return null; } })(),
    phone: input.phone || null,
  };
  const r = await fetch(`${SB_URL}/rest/v1/rpc/lhw_ticket_submit`, {
    method: "POST",
    headers: { apikey: SB_KEY, Authorization: `Bearer ${SB_KEY}`, "Content-Type": "application/json" },
    body: JSON.stringify({
      p_username: input.username || "website-visitor",
      p_type: "issue",
      p_module: moduleOf(window.location.pathname),
      p_title: input.title.slice(0, 200),
      p_description: input.description.slice(0, 4000),
      p_role: "customer",
      p_app: "cvf",
      p_meta: meta,
    }),
  });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
};

const ReportProblem = ({ className = "" }: { className?: string }) => {
  const t = useCiT();
  const user = useSelector((s: RootState) => s.Login.ContractorData) as any;
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState<null | "ok" | "err">(null);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  const send = async () => {
    if (!title.trim() && !desc.trim()) return;
    setBusy(true);
    try {
      await submitProblem({
        title: title.trim() || desc.trim().slice(0, 80),
        description: desc.trim() || title.trim(),
        username: user?.name || user?.email || user?.phoneNumber || undefined,
        phone: phone.trim() || user?.phoneNumber || undefined,
      });
      setDone("ok");
      setTitle(""); setDesc(""); setPhone("");
    } catch {
      setDone("err");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button type="button" onClick={() => { setDone(null); setOpen(true); }} className={`underline hover:text-white ${className}`}>
        {t("Website me dikkat? Batayein")}
      </button>
      {open ? (
        <div className="fixed inset-0 z-[80] flex items-end justify-center bg-black/50 p-0 sm:items-center sm:p-4" onClick={() => setOpen(false)}>
          <div
            role="dialog"
            aria-modal="true"
            className="w-full max-w-[460px] rounded-t-xl bg-white p-5 text-ci-ink shadow-xl sm:rounded-xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mb-3 flex items-start justify-between gap-3">
              <div>
                <h2 className="font-display text-[22px] font-bold uppercase leading-none text-ci-navy">{t("Dikkat batayein")}</h2>
                <p className="mt-1 text-[13px] text-ci-muted">{t("Kya kaam nahi kar raha, kis page par — ek line kaafi hai. Team dekh legi.")}</p>
              </div>
              <button type="button" aria-label="Close" onClick={() => setOpen(false)} className="rounded p-1 text-ci-muted hover:bg-ci-bg"><LuX size={20} /></button>
            </div>
            {done === "ok" ? (
              <div className="rounded-md bg-ci-okbg px-3.5 py-3 text-[14px] text-ci-ok">{t("Mil gaya — shukriya. Zaroorat padi to hum phone/WhatsApp par sampark karenge.")}</div>
            ) : (
              <div className="flex flex-col gap-2.5">
                <input
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder={t("Kya hua? (jaise: Add to cart kaam nahi kar raha)")}
                  className="h-[44px] rounded-md border border-ci-line px-3 text-[15px] focus:border-ci-navy focus:outline-none"
                  maxLength={200}
                />
                <textarea
                  value={desc}
                  onChange={(e) => setDesc(e.target.value)}
                  placeholder={t("Thoda detail (optional)")}
                  rows={3}
                  className="rounded-md border border-ci-line px-3 py-2 text-[15px] focus:border-ci-navy focus:outline-none"
                  maxLength={4000}
                />
                {!user ? (
                  <input
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder={t("Phone (optional, sirf sampark ke liye)")}
                    inputMode="tel"
                    className="h-[44px] rounded-md border border-ci-line px-3 text-[15px] focus:border-ci-navy focus:outline-none"
                    maxLength={20}
                  />
                ) : null}
                {done === "err" ? <p className="text-[13px] text-red-600">{t("Bhej nahi paye — WhatsApp par bata dein.")}</p> : null}
                <CiButton variant="orange" size="lg" disabled={busy || (!title.trim() && !desc.trim())} onClick={send}>
                  {busy ? t("Bhej rahe hain…") : t("Bhejein")}
                </CiButton>
              </div>
            )}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ReportProblem;
